import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import { postFunnelEvents } from 'features/funnel-events/actions';
import { SaveFunnelEvents } from 'features/funnel-events/types';
import { selectHasOnboardedInvest, selectPotsOnboardingState } from 'features/invest/reducers/selectors';
import { setDeviceSettingsKey } from 'actions/deviceSettings';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
import { selectPotsStatuses } from '../reducers/selectors';
import useNavigateToNextScreenForPotsOnboarding from './useNavigateToNextScreenForPotsOnboarding';
const strings = {
    continue: 'Open a savings pot',
};
const useOnboarding = (fromAutosave) => {
    const { status } = useAppSelector(selectPotsStatuses);
    const navigation = useMainStackNavigation();
    const dispatch = useAppDispatch();
    const { navigateToTab } = useTabNavigation();
    const potsOnbState = useAppSelector(selectPotsOnboardingState);
    const hasOnboardedInvest = useAppSelector(selectHasOnboardedInvest);
    const navigateToNextScreen = useNavigateToNextScreenForPotsOnboarding();
    const onboard = useCallback(() => {
        if (status === 'NOT_STARTED' && showUnavailableOnWeb('emma://save?tab=pots', strings.continue)) {
            return;
        }
        dispatch(setDeviceSettingsKey('hasTriedSettingsUpPots', true));
        if (status === 'NOT_STARTED') {
            if (fromAutosave) {
                navigateToTab('Save', { tab: 'pots' });
            }
            if (!potsOnbState?.screen || (hasOnboardedInvest && !!potsOnbState?.createPotsParams)) {
                dispatch(postFunnelEvents([SaveFunnelEvents.ONB_SAVE_NEXT_POT_TYPE]));
                navigation.navigate('SelectPotType', { isPotsOnboarding: true });
            }
            else {
                navigateToNextScreen();
            }
        }
        else {
            navigateToTab('Save', { tab: 'pots' });
        }
    }, [
        status,
        fromAutosave,
        potsOnbState?.screen,
        potsOnbState?.createPotsParams,
        hasOnboardedInvest,
        navigateToTab,
        navigateToNextScreen,
    ]);
    return [onboard, strings.continue];
};
export default useOnboarding;
